


























import { Component, Vue } from "vue-property-decorator";
import EmployeeAttendEditDayLine from "@/components/EmployeeAttendEditDayLine.vue";
import EmployeeAttendEditPairLine from "@/components/EmployeeAttendEditPairLine.vue";
import store from "@/store";
import { Models, AppConstants } from "@/core/Export";
@Component({
  components: { EmployeeAttendEditDayLine, EmployeeAttendEditPairLine }
})
export default class EmployeeAttendEdit extends Vue {
  attendEditColumns: Array<any>;
  pagination = {
    rowsPerPage: 0
  };
  constructor() {
    super();
    this.attendEditColumns = new Array<any>();
  }

  created() {
    this.onSetAttendEditColumns();
    this.onGetBaseItems();
  }

  mounted() {
    this.fixTableScrollingIssue();
  }

  fixTableScrollingIssue() {
    var isIOSDevice = !!navigator.platform.match(/iPhone|iPod|iPad/);
    if (isIOSDevice && this.appEnv.isRtl) {
      let q_table_middle = document.getElementsByClassName(
        "q-table__middle"
      )[0] as HTMLElement;
      if (q_table_middle) {
        q_table_middle.style.direction = "ltr";
        let table = q_table_middle.firstElementChild as HTMLElement;
        table.style.direction = "rtl";
      }
    }
  }

  onGetBaseItems() {
    store.dispatch(
      AppConstants.StoreActions.GetBaseItem,
      AppConstants.BaseItems.MissingEvent
    );
    store.dispatch(
      AppConstants.StoreActions.GetBaseItem,
      AppConstants.BaseItems.NotSingingReason
    );
  }

  onAddPairForDay(day: Models.EAME_DayDto) {
    let pair = new Models.EAME_PairDto();
    pair.employeeId = day.employeeId;
    pair.entryLog = new Models.EmployeeEntryExitLog();
    pair.exitLog = new Models.EmployeeEntryExitLog();
    pair.entryLog.isManualEntry = true;
    pair.entryLog.sourceCode = AppConstants.AttendEntrySource.Portal;
    pair.entryLog.notSingingReasonId = 0;
    pair.missingEventId = 0;
    pair.exitLog.isManualEntry = true;
    pair.exitLog.sourceCode = AppConstants.AttendEntrySource.Portal;
    pair.exitLog.notSingingReasonId = 0;
    pair.missingEventId = 0;
    pair.id = -1;
    pair.attendSpecialEventId = 0;
    pair.isFillTeken = false;

    let lastPair = day.pairs[day.pairs.length - 1];
    if (lastPair && day.pairs.length > 0) {
      let pairIndex = day.pairs.indexOf(lastPair);
      pair.key = `${day.id}~${pairIndex + 2}`;
    } else {
      pair.key = `${day.id}~1`;
    }
    day.pairs.push(pair);
  }

  onSetAttendEditColumns() {
    this.attendEditColumns.push({
      name: "addPair",
      field: "addPair",
      align: "left",
      style: "width: 10px;"
    });
    this.attendEditColumns.push({
      name: "date",
      field: "date",
      label: this.$t("pages.employeeAttendDetails.date"),
      align: "left",
      style: "width: 105px;"
    });
    this.attendEditColumns.push({
      name: "day",
      field: "day",
      label: this.$t("pages.employeeAttendDetails.day"),
      align: "left",
      style: "width: 105px;"
    });
    this.attendEditColumns.push({
      name: "status",
      field: "status",
      label: "",
      align: "left",
      style: "width: 10px;"
    });
    this.attendEditColumns.push({
      name: "entry",
      field: "entry",
      label: this.$t("pages.employeeAttendDetails.entry"),
      align: "left",
      style: "width: 120px;"
    });
    this.attendEditColumns.push({
      name: "entryNotSignReason",
      field: "entryNotSignReason",
      label: this.$t("pages.employeeAttendDetails.notSignReason"),
      align: "left",
      style: "width: 200px;"
    });
    this.attendEditColumns.push({
      name: "flip",
      field: "flip",
      label: "",
      align: "left"
    });
    this.attendEditColumns.push({
      name: "exit",
      field: "exit",
      label: this.$t("pages.employeeAttendDetails.exit"),
      align: "left",
      style: "width: 120px;"
    });
    this.attendEditColumns.push({
      name: "exitNotSignReason",
      field: "exitNotSignReason",
      label: this.$t("pages.employeeAttendDetails.notSignReason"),
      align: "left",
      style: "width: 200px;"
    });
    this.attendEditColumns.push({
      name: "missingEventOrSpecialEvent",
      field: "missingEventOrSpecialEvent",
      label:
        this.$t("pages.employeeAttendDetails.specialEvent"),
      align: "left",
      style: "width: 200px;"
    });
    this.attendEditColumns.push({
      name: "notes",
      field: "notes",
      label: this.$t("pages.employeeAttendDetails.notes"),
      align: "left"
    });
  }

  get employeeAttendEditData() {
    return store.getters.employeeAttendEditData;
  }

  get appEnv() {
    return store.getters.appEnv;
  }
}
